import React from 'react';

interface WelcomeOverlayProps {
    onDismiss: () => void;
}

const WelcomeOverlay: React.FC<WelcomeOverlayProps> = ({ onDismiss }) => (
    <div
        onClick={onDismiss}
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.55)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 99998,
            cursor: 'pointer',
            fontFamily: 'monospace',
        }}
    >
        <div
            onClick={(e) => e.stopPropagation()}
            style={{
                padding: '32px 40px',
                background: '#c0c0c0',
                color: '#000',
                boxShadow:
                    'inset -1px -1px #2b2b2b, inset 1px 1px #fff, inset -2px -2px #808080, inset 2px 2px #c0c0c0',
                maxWidth: 500,
                cursor: 'default',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <h2 style={{ marginBottom: 12, fontFamily: 'sans-serif' }}>欢迎</h2>
            <p style={{ marginBottom: 16, fontFamily: 'sans-serif', fontSize: 15 }}>
                左键拖拽旋转视角，滚轮缩放。把鼠标移到屏幕里就能进入桌面 OS。
                建议带上耳机，使用桌面浏览器获得最佳体验。
            </p>
            <button
                onClick={onDismiss}
                style={{
                    alignSelf: 'flex-end',
                    padding: '6px 24px',
                    background: '#c0c0c0',
                    border: 'none',
                    boxShadow: 'inset -1px -1px #2b2b2b, inset 1px 1px #fff',
                    cursor: 'pointer',
                    fontFamily: 'sans-serif',
                    fontSize: 14,
                }}
            >
                开始
            </button>
        </div>
    </div>
);

export default WelcomeOverlay;
